import React, { useState, useEffect } from "react";
import { Prompt, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import TextInput from "./common/TextInput";
import DropDown from "./common/DropDown";
import CheckBox from "./common/CheckBox";
import * as Api from "../api/progression";
import { getProfile } from "../api/profile";
import { round, getFatPctMetric, getCalories, formatDate, getYesNo, getProgressType } from "../misc/utils";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

function ProgressionPage(props)
{
    const [age, setAge] = useState(0);
    const [sex, setSex] = useState(0);
    const [preventRedirect, setPreventRedirect] = useState(false);
    const [knowFatPct, setKnowFatPct] = useState(false);
    const [isManual, setIsManual] = useState(false);
    const [progression, setProgression] = useState({
        userID: 0,
        dietDone: false,
        feltBad: false,
        height: '',
        weight: '',
        hip: undefined,
        neck: undefined,
        waist: '',
        fatPct: '',
        goal: 0,
        dietConviction: 0,
        activityType: 1,
        foodPreference: 5,
        trainningHoursAWeek: 0,
        carbs: 0,
        prots: 0,
        fats: 0,
        cals: 0,
        type: 4,
        round: 0,
        cycle: 0
    });
    const [history, setHistory] = useState([]);

    useEffect(() => {
        (async () => {
            await loadData();
        })();
    }, []); //if the second par of useEffect is an empty array, it will only execute one time when mounting the component

    async function loadData() {
        //let lastProg = await Api.getLastProgression(props.user.id);
        let profile = await getProfile(props.user.id);
        let newProg = { ...progression }
        newProg.userID = props.user.id;
        newProg.height = profile.height;
        setAge(profile.age);
        setSex(profile.sex);
        setProgression(newProg);
    }

    //async function getHistory() {
    //    let historyList;
    //    if (history === null) // If history not loaded yet
    //    {
    //        historyList = await Api.getProgressions(props.user.id);
    //        setHistory(historyList);
    //    }
    //    else
    //        historyList = history;

    //    return historyList;
    //}

    async function handleTabSelect(key) {
        if (key === "history")
        {
            if (history.length <= 0) // If history not loaded yet, load it
            {
                let historyList = await Api.getProgressions(props.user.id);
                setHistory(historyList);
            }
        }
    }

    function updateValue(
        event,
        dataType = "",
        objName = event.target.id,
        value = event.target.value,
        isValid = true,
    ) {
        if (dataType === "check")
            value = event.target.checked;
        else if (dataType === "select")
            value = Number(event.target.value);

        const updatedObj = { ...progression, [objName]: value };
        setProgression(updatedObj);
        setPreventRedirect(true);
        if (!isValid)
            toast.error("Numero no valido");
    }

    function updateFatPct(
        event,
        dataType = "",
        objName = event.target.id,
        value = event.target.value,
        isValid = true
    ) {
        let updateFatPct = true;
        const updatedObj = { ...progression };
        if (dataType === "check") {// if comes from KnowFatPct
            value = event.target.checked;
            setKnowFatPct(value);
            setPreventRedirect(true);

            if (value) // if known
                updateFatPct = false;
        }
        else {// if comes from any other
            if (knowFatPct)
                updateFatPct = false;

            updatedObj[objName] = value;
            //TO DO: verify if the !isValid message is necessary, or if can be usefull for other datatypes
            if (!isValid)
                toast.error("Numero no valido");
        }

        if (updateFatPct) {
            let newFatPct = round(getFatPctMetric(
                sex,
                updatedObj.height,
                updatedObj.neck,
                updatedObj.waist,
                updatedObj.hip
            ), 2);

            if (isNaN(newFatPct) || newFatPct < 0) {
                newFatPct = 0;
            }
            updatedObj.fatPct = newFatPct;
        }
        setProgression(updatedObj);
        setPreventRedirect(true);
    }

    function updateType(
        event,
        dataType = "",
        objName = event.target.id,
        value = event.target.value,
        isValid = true,
    ) {
        setIsManual(event.target.checked);
        if (event.target.checked)
            updateValue(null, "", "type", 7, true);
        else
            updateValue(null, "", "type", 4, true);      
    }

    async function handleSave(event) {
        event.preventDefault();
        event.target.classList.add('was-validated')
        if (!event.target.checkValidity()) {
            event.stopPropagation();
            return;
        }
        debugger;
        try {
            let stats = await Api.addProgression(progression);
            setPreventRedirect(false);
            toast.success("Progresion registrada exitosamente");
        }
        catch (error) {
            toast.error("Hubo un error al guardar");
        }
    }

    return (
        <>
            <div className="form-group">
                <h2>Progresión</h2>
                <Prompt
                    when={preventRedirect}
                    message="Estas seguro que deseas abandonar esta pagina sin guardar tus cambios?"
                />
                <form onSubmit={handleSave} validated="true" className=".needs-validation" noValidate>
                    <div style={{ minHeight: '410px' }}>
                        <Tabs defaultActiveKey="progress" className="mb-3" height="500px" onSelect={handleTabSelect}>
                            <Tab eventKey="progress" title="Registra tu avance">
                                <CheckBox id="dietDone" label="Cumpliste el programa alimenticio y horas de entrenamiento segun las indicaciones?" value={progression.dietDone} onChange={updateValue} />
                                {progression.dietDone && (
                                    <CheckBox id="feltBad" label="Sentiste alguno de estos sintomas: falta de energia, mareos, falta de sueño, estreñimiento?" value={progression.feltBad} onChange={updateValue} />
                                )}
                                <br/>
                                <div className="row mb-2 ">
                                    <div className="col-sm-12" >
                                        Actualiza los siguientes datos:
                                    </div>
                                </div>
                                {age < 18 && (
                                    <TextInput id="height" label="Altura (cm)" dataType="float" required min="10" value={progression.height} onChange={updateFatPct} />
                                )}
                                <TextInput id="weight" label="Peso (kg)" dataType="float" required min="10" value={progression.weight} onChange={updateValue} />
                                <CheckBox id="knowFatPct" label="Conoces tu porcentaje de grasa?" value={knowFatPct} onChange={updateFatPct} />
                                {!knowFatPct ? (
                                    <>
                                            <TextInput id="waist" label="Ancho de la cintura (cm)" dataType="float" min="10" required value={progression.waist} onChange={updateFatPct} />
                                            <TextInput id="neck" label="Ancho del cuello (cm)" dataType="float" min="10" required value={progression.neck} onChange={updateFatPct} />
                                        {sex === 1 && (
                                                <TextInput id="hip" label="Ancho de la cadera (cm)" dataType="float" min="10" required value={progression.hip} onChange={updateFatPct} />
                                        )}
                                        <span>
                                            Porcentaje de grasa: {progression.fatPct} <br />{" "}
                                            <br />
                                        </span>
                                    </>
                                ) : (
                                            <TextInput id="fatPercentage" label="Porcentaje de grasa" dataType="float" required min="10" value={progression.fatPct} onChange={updateValue} />
                                )}
                                <div className="row mb-2 ">
                                    <div className="col-sm-12" >
                                        Los macros de tu dieta seran los siguientes:
                                    </div>
                                </div>
                                <CheckBox id="isManual" label="Prefiero capturar mis macros yo mismo." value={isManual} onChange={updateType} />
                                <fieldset disabled={!isManual} >
                                    <TextInput id="carbs" label="Carbohidratos" dataType="float" value={progression.carbs} required min="5" step="0.001" onChange={updateValue} />
                                    <TextInput id="fats" label="Grasas" dataType="float" value={progression.fats} required min="5" step="0.001" onChange={updateValue} />
                                    <TextInput id="prots" label="Proteinas" dataType="float" value={progression.prots} required min="5" step="0.001" onChange={updateValue} />
                                    Calorias: {getCalories(progression.carbs, progression.fats, progression.prots)}
                                </fieldset>
                            </Tab>
                            <Tab eventKey="extra" title="Objetivo">
                                Si lo deseas puedes modificar cualquier parte de tu objetivo:
                                <br /><br />
                                <DropDown id="goal" label="Objetivo deseado" value={progression.goal} onChange={updateValue} list={[
                                { "id": 0, "text": "Bajar de peso (disminuir porcentaje de grasa)" },
                                { "id": 1, "text": "Aumentar masa muscular" },
                                { "id": 2, "text": "Mantenimieto (Mejorar salud)" }
                            ]} />
                                {progression.goal === 0 && (
                                    <DropDown id="dietConviction" label="Que tan rapido quieres bajar de peso?" value={progression.dietConviction} onChange={updateValue} list={[
                                    { "id": 0, "text": "Lento" },
                                    { "id": 1, "text": "Moderado" },
                                    { "id": 2, "text": "Rapido" }
                                ]} />
                            )}
                                <DropDown id="foodPreference" label="Que tipo de dieta prefieres?" value={progression.foodPreference} onChange={updateValue} list={[
                                { "id": 7, "text": "Mucho mas grasas" },
                                { "id": 6, "text": "Mas grasas" },
                                { "id": 5, "text": "Carbohidratos y grasas por igual" },
                                { "id": 4, "text": "Mas carbohidratos (Recomendado)" },
                                { "id": 3, "text": "Mucho mas carbohidratos" }
                            ]} />
                                <DropDown id="activityType" label="Actividad fisica que realizas" value={progression.activityType} onChange={updateValue} list={[
                                { "id": 1, "text": "Sedentario(Trabajas sentado y no haces ejercicio)" },
                                { "id": 2, "text": "Ligera(trabajas sentado y entrenas 3 o 4 dias por semana, o trabajas de pie todo el tiempo y entrenas menos de 5 dias)" },
                                { "id": 3, "text": "Moderada(Trabajas sentado y entrenas al menos 5 dias por semana. O trabajo pesado y no entrenas )" },
                                { "id": 4, "text": "Alta(trabajas de pie todo el tiempo y entrenas al menos de 5 dias por semana)" },
                                { "id": 5, "text": "Muy alta(trabajo pesado cargando cosas y entrenas diario)" }
                                    ]} />
                                <TextInput id="trainningHoursAWeek" label="Cuantas horas a la semana planeas hacer ejercicio" dataType="int" min="0" required value={progression.trainningHoursAWeek} onChange={updateValue} />
                            </Tab>
                            <Tab eventKey="history" title="Historial">
                                <table className="table">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>Fecha</th>
                                            <th>Cumplió</th>
                                            <th>Sintomas</th>
                                            <th>Altura</th>
                                            <th>Peso</th>
                                            {sex === 1 && (
                                                <th>Cadera</th>
                                            )}
                                            <th>Cuello</th>
                                            <th>Cintura</th>
                                            <th>% Grasa</th>
                                            <th>Carbs.</th>
                                            <th>Proteina</th>
                                            <th>Grasas</th>
                                            <th>Calorias</th>
                                            <th>Tipo</th>
                                            <th>Round</th>
                                            <th>Ciclo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {history.map(prog => {
                                            return (
                                                <tr key={prog.id}>
                                                    <td>{formatDate(prog.date)}</td>
                                                    <td>{getYesNo(prog.dietDone)}</td>
                                                    <td>{getYesNo(prog.feltBad)}</td>
                                                    <td>{prog.height}</td>
                                                    <td>{prog.weight}</td>
                                                    {sex === 1 && (
                                                        <td>{prog.hip}</td>
                                                    )}
                                                    <td>{prog.neck}</td>
                                                    <td>{prog.waist}</td>
                                                    <td>{prog.fatPct}</td>
                                                    <td>{prog.carbs}</td>
                                                    <td>{prog.prots}</td>
                                                    <td>{prog.fats}</td>
                                                    <td>{prog.cals}</td>
                                                    <td>{getProgressType(prog.type)}</td>
                                                    <td>{prog.round}</td>
                                                    <td>{prog.cycle}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </Tab>
                        </Tabs>
                    </div>                    
                    <input type="submit" value="Guardar avance" className="btn btn-primary" />
                </form>
            </div>
        </>
    );
}
export default ProgressionPage;
